import React from "react";
import { Routes, Route } from "react-router-dom";
import ConsultantDashboard from "../../ConsultantDashboard/Pages/ConsultantDashboard";
import AllJobs from "../../ConsultantAllJobs/Pages/AllJobs";
import ViewJobDetails from "../../ConsultantAllJobs/Pages/ViewJobDetails";
import SubmitCandidate from "../../ConsultantSubmitCandidate/Pages/SubmitCandidates";
import GetSentCandidateforJob from "../../ConsultantAllJobs/Pages/GetSentCandidateforJob";
import ProfileShared from "../../ConsultantProfileShared/Pages/ProfileShared";
import ShortlistedCandidate from "../../CShortlistedCandidates/Pages/ShortlistedCandidates";
import InterviewScheduled from "../../CInterviewScheduled/Pages/InterviewScheduled";
import SelectedCandidate from "../../CSelectedCandidate/Pages/SelectedCandidate";
import ConsultantPrivateRoute from "./ConsultantPrivateRoutes";

const ConsultantRoutes = () => {
  return (
    <Routes>

      <Route path="Dashboard" element={<ConsultantDashboard />} />

      <Route path="/Dashboard/All-Jobs" element={<ConsultantPrivateRoute> <AllJobs /> </ConsultantPrivateRoute>} />

      <Route path="Dashboard/Consultant-Job-Details/:jobUID" element={<ConsultantPrivateRoute><ViewJobDetails /> </ConsultantPrivateRoute>} />

      <Route path="Dashboard/Send-Candidate/:jobUID" element={<ConsultantPrivateRoute><SubmitCandidate /> </ConsultantPrivateRoute>} />

      <Route path="Dashboard/Sent-Candidate-For-Job/:jobUID" element={<ConsultantPrivateRoute><GetSentCandidateforJob /> </ConsultantPrivateRoute>} />

      <Route path="Dashboard/Profile-Shared" element={<ConsultantPrivateRoute> <ProfileShared /> </ConsultantPrivateRoute>} />
      
      <Route path="Dashboard/Shortlisted-Candidates" element={ <ConsultantPrivateRoute> <ShortlistedCandidate /> </ConsultantPrivateRoute>} />

      <Route path="Dashboard/Interview-Scheduled-Candidates" element={<ConsultantPrivateRoute> <InterviewScheduled /> </ConsultantPrivateRoute>} />

      <Route path="Dashboard/Selected-Candidates" element={ <ConsultantPrivateRoute><SelectedCandidate />  </ConsultantPrivateRoute>} />


    </Routes>
  );
};

export default ConsultantRoutes;